import React, { useMemo, useState } from "react";
import { FiPlusCircle, FiDownload } from "react-icons/fi";
import { useTranslation } from "react-i18next";


import { openS3Document } from "../lib/documents";

function DirectorDealings() {
  const { t } = useTranslation();

  const [openIndex, setOpenIndex] = useState(null);

  const filesByDirector = useMemo(
    () => [
      {
        owner: "Salvatore Gervasi",
        documents: [
          {
            date: t("main.directorDealings.documents.gervasi10May2024"),
            key: "director_dealings/2023/s_gervasi/2024_05_10_gervasi.pdf",
          },
          {
            date: t("main.directorDealings.documents.gervasi13May2024"),
            key: "director_dealings/2023/s_gervasi/2024_05_13_gervasi.pdf",
          },
          {
            date: t("main.directorDealings.documents.gervasi14May2024"),
            key: "director_dealings/2023/s_gervasi/2024_05_14_gervasi.pdf",
          },
          {
            date: t("main.directorDealings.documents.gervasi15May2024"),
            key: "director_dealings/2023/s_gervasi/2024_05_15_gervasi.pdf",
          },
          {
            date: t("main.directorDealings.documents.gervasi26March2024_1"),
            key: "director_dealings/2023/s_gervasi/gervasi_1.pdf",
          },
        ],
      },
      {
        owner: "Michele Basilicata",
        documents: [
          {
            date: t("main.directorDealings.documents.basilicata26March2024_1"),
            key: "director_dealings/2023/m_basilicata/basilicata_1.pdf",
          },
          {
            date: t("main.directorDealings.documents.basilicata26March2024_2"),
            key: "director_dealings/2023/m_basilicata/basilicata_2.pdf",
          },
        ],
      },
      {
        owner: "Andrea Polzot - Red Ant Capital",
        documents: [
          {
            date: t("main.directorDealings.documents.redAnt17May2024"),
            key: "director_dealings/2023/red_ant_capital/2024_05_17_red_ant.pdf",
          },
          {
            date: t("main.directorDealings.documents.redAnt15May2024"),
            key: "director_dealings/2023/red_ant_capital/2024_05_15_red_ant.pdf",
          },
        ],
      },
    ],
    [t]
  );

  return (
    <main className="director-page">
      <section className="director-hero">
        <div>
          <h1>{t("main.directorDealings.title")}</h1>
          <span />
        </div>
      </section>

      <section className="director-list-section">
        <div className="director-list">
          {filesByDirector.map((item, index) => {
            const firstDocument = item.documents[0];
            const isOpen = openIndex === index;

            return (
              <div className="director-row-wrapper" key={item.owner}>
                <div className="director-row">
                  <button
                    type="button"
                    className="director-open-button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-label={`${t("main.directorDealings.open")} ${
                      item.owner
                    }`}
                  >
                    <FiPlusCircle />
                  </button>

                  <button
                    type="button"
                    className="director-name-button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                  >
                    {item.owner}
                  </button>

                  {firstDocument && (
                    <a
                      href="/"
                      className="director-download"
                      aria-label={`${t("main.directorDealings.download")} ${
                        item.owner
                      }`}
                      onClick={(event) =>
                        openS3Document(event, firstDocument.key)
                      }
                    >
                      <FiDownload />
                    </a>
                  )}
                </div>

                {isOpen && (
                  <div className="director-documents">
                    {item.documents.map((doc) => (
                      <a
                        key={doc.key}
                        href="/"
                        onClick={(event) => openS3Document(event, doc.key)}
                      >
                        {doc.date}
                        <FiDownload />
                      </a>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
}

export default DirectorDealings;